import { Component, OnInit, ElementRef, ViewChild, Inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LOCAL_STORAGE, WebStorageService } from 'ngx-webstorage-service';
import { CommonService } from '../services/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService, Response } from '../dataService/data.service';
import { GlobalVariable } from '../app.component';
import { NgbRatingConfig } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { ChangeDetectionStrategy } from '@angular/compiler/src/core';
import { FormGroup, FormControl, Validators, FormBuilder, NgForm } from '@angular/forms';

@Component({
  selector: 'app-optout',
  templateUrl: './optout.component.html',
  styleUrls: ['./optout.component.scss']
})
export class OptoutComponent implements OnInit {
  private BASE_URL = GlobalVariable;
  outlet_id: String = this.storage.get('outlet_id');
  slug_value: String;
  business_logo: string;
  business_name: string;
  customer_name: string;
  optin_status: string;
  feedback: string;
  replied_by: string;
  feedback_reply: string;
  campaign_content: String;
  public loading = false;
  logo_url: String;
  whatsappForm: FormGroup;
  isValidFormSubmitted: Boolean = true;
  newwhatsappnumber: Boolean = false;
  newwhatsappnumber1: Boolean = false;
  newwhatsappnumber2: Boolean = false;
  slug_status: Boolean = true;
  optin_list: any = [];
  smsOptin: boolean = false;
  whatsappOptin: boolean = false;
  emailOptin: boolean = false;
  showDefaultOptOut: boolean;
  showOptedOutText: boolean;
  slugMedium: any;
  optInMedium: boolean = false;

  constructor(private commonservice: CommonService,
    private HttpService: DataService,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private router: Router,
    private route: ActivatedRoute,
    private toastrService: ToastrService, private spinner: NgxSpinnerService, public formBuilder: FormBuilder) { }

  ngOnInit() {
    this.loading = true;
    let res: Response;

    this.whatsappForm = this.formBuilder.group({
      'whatsapp_number': ['', Validators.compose([Validators.required])],
    });

    this.route.params.forEach(val => {
      this.slug_value = val['slug'];
    });

    this.route.params.forEach(val => {
      this.slugMedium = val['medium'];
    });

    console.log(this.slugMedium)

    const json_data = {
      'slug': this.slug_value
    };

    const optin_service = this.HttpService.postjson(this.BASE_URL.OPTOUT_TRACKING, json_data);
    optin_service.subscribe((data: Response) => {
      res = data;
    }, error => {
      //this.toastrService.error(error.error.message);       
      this.slug_status = false;
    }, () => {
      this.business_name = res.data['business_name'];
      this.business_logo = res.data['business_logo'];
      this.customer_name = res.data['contact_name'];
      this.optin_status = res.data['optin_status'];
      this.optin_list = res.data['optin_lists'];
      this.optin_list.forEach(opt => {
        if (opt.status == 'Opt In' && this.slugMedium == opt.optin_medium.toLowerCase()) {
          this.optInMedium = true;
        }
      });

    });

    setTimeout(() => {
      this.loading = false;
    }, 1000);


  }


  optIn(medium) {
    console.log(medium);
    let res: Response;
    const json_data = {
      "slug": this.slug_value,
      "medium": medium,
    }

    const data_service = this.HttpService.put(this.BASE_URL.OPTOUT_TRACKING, json_data);
    data_service.subscribe((data: Response) => {
      res = data;
    }, error => {
      this.toastrService.error(error.error.message);
    }, () => {
      if (res.code === 200 || res.code === 201) {
        this.toastrService.success(res.data['message']);
      } else if (res.code === 404 || res.code === 400 || res.code === 206) {
        this.toastrService.warning(res.data['message']);
      }

      setTimeout(() => {
        window.location.reload();
      }, 1000);
    });



  }

  optinBtn(event) {
    let optin;
    if (event == 'yes') {
      optin = 1;
      this.newwhatsappnumber = true;
      this.newwhatsappnumber1 = false;
      this.newwhatsappnumber2 = true;
    } else if (event == 'no') {
      optin = 0;
      this.newwhatsappnumber = true;
      this.newwhatsappnumber1 = true;
      this.newwhatsappnumber2 = false;
    }
    let res: Response;
    const json_data = {
      "slug": this.slug_value,
      //"optin_action": optin,       
    }

    const data_service = this.HttpService.put(this.BASE_URL.OPTOUT_TRACKING, json_data);
    data_service.subscribe((data: Response) => {
      res = data;
    }, error => {
      this.toastrService.error(error.error.message);
    }, () => {
      if (res.code === 200 || res.code === 201) {
        this.toastrService.success(res.data['message']);
      } else if (res.code === 404 || res.code === 400) {
        this.toastrService.warning(res.data['message']);
      }
    });

    setTimeout(() => {
      window.location.reload();
    }, 1000);


  }

  get whatsappFormData() {
    return this.whatsappForm.controls;
  }

  whatsappBtn() {

    let res: Response;
    const json_data = {
      "slug": this.slug_value,
      // "optin_action": 1,
      // "whatsapp_number": this.whatsappFormData.whatsapp_number.value,        
    }
    const data_service = this.HttpService.put(this.BASE_URL.OPTOUT_TRACKING, json_data);
    data_service.subscribe((data: Response) => {
      res = data;
    }, error => {
      this.toastrService.error(error.error.message);
    }, () => {
      if (res.code === 200 || res.code === 201) {
        this.toastrService.success(res.data['message']);
      } else if (res.code === 404 || res.code === 400) {
        this.toastrService.warning(res.data['message']);
      }
    });

  }

  whatsappBtnReset() {
    this.whatsappForm.reset();
  }


}
